import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';
import * as search from '_core/utils/search';
import * as api from '_core/utils/api';

import { getTextApiParam } from './Text';


export const SponsorValue = React.memo((props) => {
  const {
    classes,
    
    token,
    column,
    data
  } = props;
  
  
  const [sponsor, setSponsor] = React.useState();
  
  const value = math.getField(data, column.nameSplit[0]);
  
  React.useEffect(() => {
    if (value) {
      api.getClientVisitor({ token, fields: 'id,login,lastname,firstname,patronymic' }, value)
        .then((data) => setSponsor(data[value]))
        .catch((error) => {
          console.error(error);
          
          setSponsor(undefined);
        });
    } else {
      setSponsor(undefined);
    }
  }, [token, value]);
  
  
  if (!value)
    return '-';
  
  if (!sponsor) {
    return (
      <Skeleton
        animation="wave"
        variant="rect"
        className={classes.skeleton}
      />
    );
  }
  
  return (
    <>
      {sponsor.login}
      
      {sponsor.lastname || sponsor.firstname || sponsor.patronymic ? (
        <>
          &nbsp;
          
          ({[sponsor.lastname, sponsor.firstname, sponsor.patronymic].filter(Boolean).join(' ')})
        </>
      ) : null}
    </>
  );
});

export const getSponsorApiParam = getTextApiParam;

export const getSponsorExportValue = async (props, column, data) => {
  const {
    token
  } = props;
  
  
  try {
    const value = math.getField(data, column.nameSplit[0]);
    
    if (!value)
      return '-';
    
    const sponsor = (api.getClientVisitor({ token, fields: 'id,login,lastname,firstname,patronymic' }, value))[value];
    
    if (!sponsor)
      return '-';
    
    if (sponsor.lastname || sponsor.firstname || sponsor.patronymic)
      return sponsor.login + ' (' + [sponsor.lastname, sponsor.firstname, sponsor.patronymic].filter(Boolean).join(' ') + ')';
    
    return sponsor.login;
  } catch (e) {
    console.error(e);
    
    return '-';
  }
};
